import blocks from '../../blocks';
import site from '../../site';

const getUsedBlockTemplatesIds = (state, pageId) => {
  const usedBlocks = site.selectors.getUsedBlocks(state, pageId);
  const usedBlocksMap = usedBlocks.reduce((result, blockId) => {
    result.set(blockId, true);

    return result;
  }, new Map());

  const blockList = blocks.selectors.getBlocks(state);

  const usedBlockTemplatesIds = blockList.reduce((sum, block) => {
    if (usedBlocksMap.has(block.id) && block.templateId) {
      sum.add(block.templateId);
    }

    return sum;
  }, new Set());

  return [...usedBlockTemplatesIds];
};

export default getUsedBlockTemplatesIds;
